export const DELIVERYOPTION_SELECTED_NAME = 'DELIVERYOPTION_SELECTED_NAME';
export const ITEM_AVAILABILITY = 'ITEM_AVAILABILITY';
export const BOPIS_ITEM_AVAILABILITY = 'BOPIS_ITEM_AVAILABILITY';
export const STOP_OOS_STORE_TOOLTIP = 'STOP_OOS_STORE_TOOLTIP';
